import React, { useMemo, useState } from "react";

import {
  InspectionResult,
  InspectionResultSymbol,
} from "../enum";
import { FormattedDate } from "react-intl";
import InspectionForwardingDialog from "./InspectionForwardingDialog";

const InspectionStatementControl = ({ statement, administrativeAutorities, onInspectionResult, onInspectionEdit }) => {
  const [showForwardTo, setShowForwardTo] = useState(false);
  const [forwardTo, setForwardTo] = useState(administrativeAutorities?.defaultOrp || '');

  const { lastInspection, inspectionMissed, administrativeAutoritiesOptions } = useMemo(() => {
    const inspections = [...(statement.inspections || [])].filter(i => !i.deleted).sort(
        (a, b) => new Date(b.inspectionDate) - new Date(a.inspectionDate)
    );

    // Statement is more than a year old (last send/update) and has no inspections
    const lastStatementSentTimestamp = Math.max(
        new Date(statement.creationDate).getTime(),
        statement.lastModified ? new Date(statement.lastModified).getTime() : 0
    );

    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

    // Is missed inspection after one year from last statement send/update
    const lastInspection = inspections[0];
    const inspectionMissed = !lastInspection && lastStatementSentTimestamp < oneYearAgo.getTime();

    const administrativeAutoritiesOptions = [...(administrativeAutorities || [])].sort();

    return { lastInspection, inspectionMissed, administrativeAutoritiesOptions };
  }, [statement, administrativeAutorities]);

  const chooseForwardTo = (event) => {
    event.stopPropagation();
    setShowForwardTo(true);
  }

  const cancelChooseForwardTo = (event) => {
    event.stopPropagation();
    setShowForwardTo(false);
  }

  return (
    <div className="cro__inspectionControl">
      {inspectionMissed && (
          <div className="inspectionControl__missed">
            promlčeno
          </div>
      )}
      {lastInspection && (
        <div className={`inspectionControl__result ${lastInspection.result.toLowerCase()}`} onClick={(e) => {
          e.stopPropagation();
          onInspectionEdit(lastInspection.id);
        }}>
          <span className="inspectionControl__resultSymbol">{ InspectionResultSymbol[lastInspection.result] }</span>
          <span><FormattedDate value={lastInspection.inspectionDate} /></span>
        </div>
      )}
      {(!lastInspection && !inspectionMissed && !showForwardTo) && (
        <div className="inspectionControl__selector">
          <div className="inspectionControl__state ok" onClick={(e) => {
            onInspectionResult(statement.id, InspectionResult.OK, undefined, undefined);
            e.stopPropagation();
          }}>
            {InspectionResultSymbol.OK}
          </div>
          <div className="inspectionControl__state problem" onClick={chooseForwardTo}>
            {InspectionResultSymbol.PROBLEM}
          </div>
        </div>
      )}

      {showForwardTo && administrativeAutorities && administrativeAutorities.length && (
        <InspectionForwardingDialog
          onCancel={cancelChooseForwardTo}
          forwardTo={forwardTo}
          administrativeAutoritiesOptions={administrativeAutoritiesOptions}
          onForward={(result, forwardTo, note) => {
            onInspectionResult(statement.id, result, forwardTo, note);
            setShowForwardTo(false);
          }} />
      )}
    </div>
  );
}

export default InspectionStatementControl;